import { render } from "./Agent.vue?vue&type=template&id=18f2d5b2"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__